import React from 'react'
import { isBrowser, isMobile } from 'react-device-detect'
import pdfLogo from 'images/pdf-logo.png'
import bg from 'images/personas/bg-countries.jpg'
import Chart from '../../form/Chart'
import ChartLabels from '../../ChartLabels'
import { calculateTotal } from '../../../helpers/functions'
import LimitedViewChart from './LimitedViewChart'

const CountriesBreakdown = ({
  data,
  limitedView,
  photo
}) => {
  const total = calculateTotal(data, 'value')

  return (
    <React.Fragment>
      <section className="section" data-anchor="countries_breakdown">
        <div
          className="slider-box slider-box--pdf-p0 image-layer image-layer--black bg-center bg-cover bg-no-repeat box-shadow-box flex relative sm-block"
          style={{ backgroundImage: `url('${photo[0].url}')` }}
        >
          <div className="col-12 flex flex-column relative z1">
            <div className="flex-auto">
              <div className="flex pt4 px4 sm-p2">
                <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
                <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
                <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
                <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
                <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
              </div>

              <h2 className="persona-sub-title px4 py3 sm-px2 sm-py3 text-white">Where are the people interested in purchasing goods or services from your industry?</h2>
            </div>

            <div className="px4 sm-p0">
              <div className="bg-white rounded-top-30">
                {limitedView
                  ? <div className="center p4 relative"><LimitedViewChart /></div>
                  : <div className="relative">
                    <div className="pdf-chart-container relative">
                      <div className="absolute bg-chart-colored center circle flex flex-center flex-justify-center left-50p text-white top-50p transform-center" style={{ height: '230px', margin: '5px 0 0 5px', width: '230px' }} />

                      <Chart
                        data={data}
                        name="breakdown by countries"
                        height={isBrowser ? 400 : 350}
                        width={isBrowser ? 850 : 300}
                        innerRadius={120}
                        outerRadius={140}
                        hideLabel={isMobile && true}
                      />
                    </div>

                    <div className="pdf-chart-labels hidden p3 pdf-show relative sm-show z1">
                      <div className="flex flex-justify-center">
                        <div>
                          {data.map((item, index) => {
                            return (
                              <ChartLabels
                                index={index}
                                item={item}
                                total={total}
                              />
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
};

export default CountriesBreakdown
